import { Telegram as TelegramIcon } from '@material-ui/icons';
import clsx from 'clsx';
import React from 'react';

import RaritySniper from '../../../../common/images/rarity-sniper.png';
import { ReactComponent as DiscordIcon } from '../../../../common/svg/socials/icon-discord.svg';
import { ReactComponent as FacebookIcon } from '../../../../common/svg/socials/icon-facebook.svg';
import { ReactComponent as InstagramIcon } from '../../../../common/svg/socials/icon-instagram.svg';
import { ReactComponent as TwitterIcon } from '../../../../common/svg/socials/icon-twitter.svg';
import styles from './styles.module.css';

interface Props {
  isOpen: boolean;
}

export const Footer = ({ isOpen }: Props) => {
  const containerCn = clsx(styles.footer, !isOpen && styles.closed);

  return (
    <div className={containerCn}>
      <a
        target="_blank"
        rel="noreferrer"
        href="https://raritysniper.com/nft-drops-calendar"
        className={styles.socialIcons}
      >
        <img
          src={RaritySniper}
          alt="rarity sniper logo"
          className={styles.icon}
        />
      </a>
      <a
        target="_blank"
        rel="noreferrer"
        href="https://twitter.com/mogulofficial_"
        className={styles.socialIcons}
      >
        <TwitterIcon className={styles.icon} />
      </a>
      <a
        target="_blank"
        rel="noreferrer"
        href="https://www.instagram.com/mogul.official/"
        className={styles.socialIcons}
      >
        <InstagramIcon className={styles.icon} />
      </a>
      <a
        target="_blank"
        rel="noreferrer"
        href=" https://discord.com/invite/MogulProductions"
        className={styles.socialIcons}
      >
        <DiscordIcon className={styles.icon} />
      </a>

      <a
        target="_blank"
        rel="noreferrer"
        href="https://t.me/mogulproductions"
        className={styles.socialIcons}
      >
        <TelegramIcon
          style={{ transform: 'scale(1.35)' }}
          className={styles.icon}
        />
      </a>

      <a
        target="_blank"
        rel="noreferrer"
        href="https://www.facebook.com/mogulproduction/"
        className={styles.socialIcons}
      >
        <FacebookIcon className={styles.icon} />
      </a>
    </div>
  );
};
